module.exports = __webpack_public_path__ + "img/625-43b039.png";